<template>
  <div class="ds-live-notifier" data-testid="ds-live-notifier">
    <DsLiveToast v-for="toast in toasts" :key="toast.id" :toast="toast" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useDsLiveNotifierStore } from "./DsLiveNotifierStore";
import { DsLiveToastStyleEnum } from "./DsLiveToastStyleEnum";

import DsLiveToast from "./DsLiveToast.vue";

import type { DsLiveNotificationToast } from "./DsLiveNotifier.types";

defineOptions({
  name: "DsLiveNotifier",
});

const maxQueue = 5;
//const toasts = ref([] as DsLiveNotificationToast[]);

const toasts = computed((): DsLiveNotificationToast[] => {
  const _toasts: DsLiveNotificationToast[] = [];
  let i = 0;
  useDsLiveNotifierStore().toasts.forEach((toast) => {
    if (i < maxQueue) {
      toast.duration = toast.duration ?? 10;
      toast.enableClose = toast.enableClose ?? true;
      if (toast.app_notification_style === DsLiveToastStyleEnum.Success) {
        toast.themeColor = "green";
      } else if (toast.app_notification_style === DsLiveToastStyleEnum.Notice) {
        toast.themeColor = "blue";
      } else if (
        toast.app_notification_style === DsLiveToastStyleEnum.Critical
      ) {
        toast.themeColor = "red";
      } else if (
        toast.app_notification_style === DsLiveToastStyleEnum.Warning
      ) {
        toast.themeColor = "yellow";
      } else {
        toast.themeColor = "gray";
      }
      _toasts.push(toast);
      i++;
    }
  });
  _toasts.reverse();
  return _toasts;
});

/**
 * TODO I don't know why the subscribe method doesn't work on unit test
 * I leave this code for the future. But, at this moment we continue working
 * with a computed variable.
 */
// useDsLiveNotifierStore().$subscribe((_, state) => {
//   toasts.value = [];
//   let i = 0;
//   state.toasts.forEach((toast) => {
//     if (i < maxQueue) {
//       toast.duration = toast.duration ?? 10;
//       toast.enableClose = toast.enableClose ?? true;
//       if (toast.app_notification_style === DsLiveToastStyleEnum.Success) {
//         toast.themeColor = "green";
//       } else if (toast.app_notification_style === DsLiveToastStyleEnum.Notice) {
//         toast.themeColor = "blue";
//       } else if (
//         toast.app_notification_style === DsLiveToastStyleEnum.Critical
//       ) {
//         toast.themeColor = "red";
//       } else if (
//         toast.app_notification_style === DsLiveToastStyleEnum.Warning
//       ) {
//         toast.themeColor = "yellow";
//       } else {
//         toast.themeColor = "gray";
//       }
//       toasts.value.push(toast);
//       i++;
//     }
//   });
// });
</script>

<style lang="scss" scoped>
.ds-live-notifier {
  @apply fixed bottom-5 right-2.5 sm:right-5 space-y-3 z-30;
}
</style>
